const FETCH_INTERNALS = 'fetch_internals';
const FETCH_INTERNALS_CSV = 'fetch_internals_csv';
const FETCH_INTERNAL = 'fetch_internal';
const DELETE_INTERNAL = 'delete_internal';
const PERSIST_INTERNAL = 'persist_internal';
export default {
    FETCH_INTERNALS,
    FETCH_INTERNALS_CSV,
    FETCH_INTERNAL,
    DELETE_INTERNAL,
    PERSIST_INTERNAL,
};
